<!--
 * @Author: yggira ira1982@gmail.com
 * @Date: 2022-12-16 16:51:49
 * @LastEditors: yggira ira1982@gmail.com
 * @LastEditTime: 2022-12-19 11:44:44
 * @FilePath: /cxcamp-parking-backend/src/components/ClearPanel.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="page-container">
    <el-container style="height: 500px; border: 1px solid #eee">
      <el-container>
        <el-header style="text-align: right; font-size: 12px">
          <Header v-if="$route.name != 'Login'" ref="Header"></Header>
        </el-header>
        <el-main>
          <div style="background-color:#F2F4F9;">
            <router-view :key="$route.fullPath"></router-view>
          </div>
        </el-main>
      </el-container>
    </el-container>

    <main id="main-container" :class="{none: $route.name == 'Login' }"></main>
  </div>
</template>

<script>
  import Header from "./Header";
  import Menu from "./Menu";
  import Util from "../Util.js";
  export default {
    name: "Panel",
    components: {
      Header
    },
    data() {
      return {

      };
    },
    computed: {
    },
    watch: {},
    mounted() {},
    methods: {}
  };

</script>

<style lang="less">
  .show_menu {
    display: block;
  }
   .is_hiden_menu {
    display: none;
  }

  #page-container {
    overflow-x: auto;
  }

  .el-container {
    border: none !important;
    height: 100vh !important;
  }

  .el-main {
    background: rgb(238, 241, 246);
  }
  .el-message-box {
    width: 360px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/ClearPanel.vue